import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';

const styles = theme => ({
  image: {
    width: 60,
    height: 60,
    fontSize: 60,
    color: '#ddd'
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%'
  },
  paper: {
    padding: theme.spacing.unit * 2,
    paddingLeft: 0,
    marginLeft: theme.spacing.unit * 2,
    borderBottom: '1px solid #d9d9d9',
    margin: 'auto',
    maxWidth: '100%'
  },
  tabs: {
    borderBottom: '1px solid #d9d9d9'
  }
});

function SourcingList(props) {
  const Config = {
    purchase: {
      apiPath: '/archives/compPotVendor/list',
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/purchase/sourcing/detail',
      isInviteStatusConfirm: 0,
      orderProperty: 'createTime',
      searchBarPlaceholder: '请输入供应商编码或者名称查询',
      tabs: ['全部', '申请中', '邀约中', '待审核', '已加入'],
      tabConfig: [
        undefined, //全部
        undefined, //申请中
        1,
        4,
        2
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  const { classes } = props;

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  self.beforeSearch = async function () {
    self.searchQueries = {
      inviteStatus: config.tabConfig[currentTab]
    };
    self.searchQueries.applyStatus = currentTab === 1 ? 1 : undefined;
    // self.searchQueries.inviteStatus = currentTab === 5 ?  2 : undefined;
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-box">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span>{item}</span>
                    {count[index] && <i className="u-num">{count[index]}</i>}
                  </li>
                ))}
              </ul>
              {/* {searchKey && (
                <div className="searchKeyBox">
                  查询信息：
                  <div onClick={handleClear}>
                    <span className="singleOmission">{searchKey}</span>
                    <ClearIcon
                      className="verticalMiddle"
                      color="primary"
                      fontSize="inherit"
                    />
                  </div>
                </div>
              )} */}
            </div>
            <div className="list-total">{total}</div>
            <PanelBody>
              {updateTs > 0 &&
                list.map((item, index) => (
                  <Link
                    to={`${config.detailLink}/${companyCode}/${item.xkUniqueCode}`}
                    key={index}
                    className="m-list-item"
                  >
                    <Paper
                      elevation={0}
                      square={true}
                      className={classes.paper}
                    >
                      <Grid container spacing={16}>
                        <Grid item>
                          <ButtonBase className={classes.image}>
                            {item.vendorLogo ? (
                              <img
                                className={classes.img}
                                alt="complex"
                                src={item.vendorLogo}
                              />
                            ) : (
                              <i className="icon-supplier"></i>
                            )}
                          </ButtonBase>
                        </Grid>
                        <Grid item xs={true} sm container>
                          <Grid
                            item
                            xs
                            container
                            direction="column"
                            spacing={16}
                          >
                            <Grid item xs>
                              <Typography color="textSecondary">
                                {item.innerVendorCode}
                              </Typography>
                              <Typography gutterBottom variant="subtitle1">
                                {item.innerVendorName}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Link>
                ))}
              {!showLoading && list.length === 0 && (
                <LoadMore showLine> 暂无数据</LoadMore>
              )}
            </PanelBody>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

SourcingList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(withStyles(styles)(SourcingList));
